<template lang="pug">
    b-row.header(align-v="center")
      b-col
        BackView(@back="back" @BackVal="BackVal")
        h1.title {{title}}
        h6.sub-title {{subTitle}}
</template>

<script>
 import { BIconChevronLeft } from 'bootstrap-vue';
 import BackView from '@/components/general/BackView';

 export default {
   props: {
     title: {
       type: String,
       default: '',
     },
     subTitle: {
       type: String,
       default: '',
     },
     BackVal: {
       type: String,
       default: 'Back',
     },
     hasBack: {
       type: Boolean,
       default: true
     }
   },
   methods: {
     back() {
       this.$emit('back');
     }
   },
   components: {
     BackView,
   }
 };
</script>
<style lagn="scss" scoped>
 .header {
	 text-align: left;
	 height: 25%;
	 background: $color;
	 .title {
		 text-align: left;
		 font-weight: bold;
		 font-size: 5.6vmin;
		 font-family: $font-serif;
	 }
	 .sub-title {
		 font-weight: bold;
		 font-size: 4.4vmin;
		 line-height: 100%;
		 font-family: $font-serif;
	 }
 }
</style>
